import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import StatusBadge from "@/components/StatusBadge";
import { PlusCircle } from "lucide-react";

export default function PortalWorkOrders() {
  const [wos, setWos] = useState([]);
  const [filter, setFilter] = useState("all");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/work-orders").then((r) => {
      setWos(r.data);
      setLoading(false);
    });
  }, []);

  const filtered = filter === "all" ? wos : wos.filter((w) => w.status === filter);

  const filters = [
    { key: "all", label: "All" },
    { key: "pending", label: "Pending" },
    { key: "assigned", label: "Assigned" },
    { key: "in_progress", label: "In progress" },
    { key: "completed", label: "Completed" },
  ];

  return (
    <div className="space-y-6">
      <div className="flex items-end justify-between flex-wrap gap-4">
        <div>
          <div className="text-[10px] uppercase tracking-[0.28em] text-slate-500">Work orders</div>
          <h1 className="font-display text-3xl md:text-4xl tracking-tighter font-medium mt-2">All work orders</h1>
        </div>
        <Link
          to="/portal/work-orders/new"
          data-testid="wo-list-new-btn"
          className="inline-flex items-center gap-2 px-4 py-2 bg-[#1E40AF] hover:bg-[#1E3A8A] text-white text-sm font-semibold rounded-sm"
        >
          <PlusCircle className="h-4 w-4" /> New work order
        </Link>
      </div>

      <div className="flex flex-wrap gap-1 border border-slate-200 bg-white p-1 w-fit">
        {filters.map((f) => (
          <button
            key={f.key}
            data-testid={`filter-${f.key}`}
            onClick={() => setFilter(f.key)}
            className={`px-3 py-1.5 text-xs font-medium rounded-sm ${
              filter === f.key ? "bg-[#0B192C] text-white" : "text-slate-600 hover:bg-slate-100"
            }`}
          >
            {f.label}
          </button>
        ))}
      </div>

      <div className="bg-white border border-slate-200">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-[10px] uppercase tracking-[0.2em] text-slate-500">
            <tr>
              <th className="text-left px-5 py-3 font-semibold">ID</th>
              <th className="text-left px-5 py-3 font-semibold">Property</th>
              <th className="text-left px-5 py-3 font-semibold">Service</th>
              <th className="text-left px-5 py-3 font-semibold">Priority</th>
              <th className="text-left px-5 py-3 font-semibold">Status</th>
              <th className="text-right px-5 py-3 font-semibold">Created</th>
            </tr>
          </thead>
          <tbody>
            {loading && (
              <tr><td colSpan="6" className="px-5 py-10 text-center text-slate-400">Loading…</td></tr>
            )}
            {!loading && filtered.length === 0 && (
              <tr><td colSpan="6" className="px-5 py-10 text-center text-slate-400">No work orders match this filter.</td></tr>
            )}
            {filtered.map((wo) => (
              <tr key={wo.id} className="border-t border-slate-100 hover:bg-slate-50">
                <td className="px-5 py-3 font-mono-alt text-xs text-slate-500">{wo.id.slice(-6).toUpperCase()}</td>
                <td className="px-5 py-3">
                  <Link to={`/portal/work-orders/${wo.id}`} data-testid={`wo-row-${wo.id}`} className="text-slate-900 hover:text-[#1E40AF] font-medium">
                    {wo.property_address}
                  </Link>
                </td>
                <td className="px-5 py-3 text-slate-600">{wo.service_type}</td>
                <td className="px-5 py-3 text-slate-600 capitalize">{wo.priority}</td>
                <td className="px-5 py-3"><StatusBadge status={wo.status} /></td>
                <td className="px-5 py-3 text-right text-xs text-slate-500 tabular-nums">
                  {new Date(wo.created_at).toLocaleDateString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
